module.exports = __webpack_public_path__ + "img/LTS_AG_CISA.f0208f0f.gif";